import React, {useEffect} from "react";
import {useAppContext} from "@/contexts/app";


export default function PageTitle({pageTitle}: { pageTitle: string}) {
    const {setPageTitle} = useAppContext();

    useEffect(() => {
        setPageTitle(pageTitle);
    }, [pageTitle]);
    return (
        <></>
    );
}
